import getErrorMessage from './getErrorMessage';

const handleFormError = ({ enqueueSnackbar }, error, errorMessage) => {
  enqueueSnackbar(errorMessage || getErrorMessage(error), {
    variant: 'error',
  });
};

export default handleFormError;
